/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../utility/Auth';
import { ContactButton, IButton } from '../../layout/components/button';
import { Row, Column} from '../../layout/components/dom';
import { useGlobal } from '../../utility/CTX';
import { useEffect } from 'react';
import { fetchUserData } from '../../utility/External';
import { useState } from 'react';
import { useCallback } from 'react';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../../utility/firebase';







function Unsubscribe() {
    const session = useSession();
    const { theme, app, dispatch } = useGlobal();
    const navigate = useNavigate();
    const [unsubscriptions, setUnsubscriptions] = useState([]);
  
    useEffect(() => {
        if (session?.user) {
          fetchUserData(session?.user)
            .then((res) => {
              console.log(res);
              setUnsubscriptions(res?.unsubscriptions || []);
            })
            .catch((err) => {
              console.error(err);
            })
        }
      }, [session?.user?.uid]);



    const toggle = useCallback(async (key) => {
        if (session?.user) {
            console.log('toggling', key);
            let newUnsubscriptions;
            if (unsubscriptions.includes(key)) {
                newUnsubscriptions = unsubscriptions.filter(k => k !== key);
            } else {
                newUnsubscriptions = [ ...unsubscriptions, key ];
            };
            console.log('setting new unsubscriptions', newUnsubscriptions);
            await setDoc(doc(db, "users", session?.user?.uid), { unsubscriptions: newUnsubscriptions });
            fetchUserData(session?.user)
            .then((res) => {
              console.log(res);
              setUnsubscriptions(res?.unsubscriptions || []);
            })
            .catch((err) => {
              console.error(err);
            })
        };
    }, [unsubscriptions, session?.user, setUnsubscriptions]);

    return <Column style={{alignItems: 'center'}}>
        <Column style={{width: 300, background: theme.bg2, margin: '50px auto', padding: '5px 10px', borderRadius: 5}}>
            <Row style={{margin: '10px auto'}}>
                <h2>Email Group Preferences</h2>
            </Row>

            {!session?.user && <>
                <div style={{color: theme.orange, margin: 'auto'}}>Click here to Sign In</div>
            </>}

            {session?.user && <>
                <Row>
                    <div>Updates, Announcements</div>
                    <div style={{ flexGrow: 1 }} />
                    <IButton value={!unsubscriptions.includes('updates') ? 'toggle_on' : 'toggle_off'} onColor={theme.green} 
                        selected={!unsubscriptions.includes('updates')} 
                        onClick={() => toggle('updates')} />
                </Row>
                <Row>
                    <div>Tips, Tutorials, Resources</div>
                    <div style={{ flexGrow: 1 }} />
                    <IButton value={!unsubscriptions.includes('resources') ? 'toggle_on' : 'toggle_off'} onColor={theme.green} 
                        selected={!unsubscriptions.includes('resources')} 
                        onClick={() => toggle('resources')} />
                </Row>
                <Row>
                    <div>Feedback, Polls</div>
                    <div style={{ flexGrow: 1 }} />
                    <IButton value={!unsubscriptions.includes('feedback') ? 'toggle_on' : 'toggle_off'} onColor={theme.green} 
                        selected={!unsubscriptions.includes('feedback')}  
                        onClick={() => toggle('feedback')} />
                </Row>
                <Row>
                    <div>Newsletter</div>
                    <div style={{ flexGrow: 1 }} />
                    <IButton value={!unsubscriptions.includes('newsletter') ? 'toggle_on' : 'toggle_off'} onColor={theme.green} 
                        selected={!unsubscriptions.includes('newsletter')}  
                        onClick={() => toggle('newsletter')} />
                </Row>
            </>}
        </Column>


        <Row style={{margin: 30, justifyContent: 'center'}}>
            <ContactButton />
        </Row>

    </Column>
}

export default Unsubscribe